<div class="contenitore">
  <mat-accordion class="accordion" multi #accordion="matAccordion">
    <mat-expansion-panel (opened)="statoPanel.set(true)" (closed)="statoPanel.set(false)">
      <mat-expansion-panel-header>
        <mat-panel-title> Licenze base </mat-panel-title>
        <mat-panel-description>
          @if (!this.statoPanel()) {
            Apri per visualizzare maggiori informazioni sulle licenze...
          }
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="cont-exp">
        <div class="cont-tab">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div style="display: flex; column-gap: 40px">
              <div class="contenitore-legenda">
                <div class="punto-legenda-attiva"></div>
                <div class="label-legenda">Licenza Attiva</div>
              </div>
              <div class="contenitore-legenda">
                <div class="punto-legenda-futura"></div>
                <div class="label-legenda">Prossimo Rinnovo</div>
              </div>
              <div class="contenitore-legenda">
                <div class="punto-legenda-scaduta"></div>
                <div class="label-legenda" style="font-style: italic">Licenza Scaduta</div>
              </div>

              @if (arraySettori.length) {
                <div class="contenitore-legenda">
                  <div
                    class="label-legenda estensione-settoriale"
                    matTooltipPosition="right"
                    [matTooltip]="'Estensioni Settoriali per la licenza attiva'"
                  >
                    <a *ngFor="let set of arraySettori">{{ ' • ' + set.titolo }}</a>
                  </div>
                </div>
              }
            </div>

            <div class="cont-bottoni">
              <button
                mat-flat-button
                color="accent"
                (click)="estensioneLicenza()"
                style="max-width: 200px !important; height: 35px !important"
              >
                <mat-icon>add</mat-icon>
                Estensione Licenza
              </button>
              <button
                mat-flat-button
                color="primary"
                (click)="aggiungiRinnovo()"
                class="primary-button"
                style="max-width: 200px !important; height: 35px !important"
              >
                <mat-icon>add</mat-icon>
                Aggiungi Rinnovo
              </button>
            </div>
          </div>
          <app-lista-tabellare
            #tabellaLicenzaBase
            [fnCaricamentoDati]="fnCaricamentoDatiLicenzaBase"
            [colonne]="colonneLicenzaBase ? colonneLicenzaBase : {}"
            [maxNrButton]="1"
            [isFiltri]="false"
            (bottoniListaClick)="bottoniListaClick($event)"
            [fnCaricamentoStyle]="fnCaricamentoStyle"
          >
          </app-lista-tabellare>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel
      *ngIf="!isUtenteGo()"
      (opened)="statoPanelAggiuntivi.set(true)"
      (closed)="statoPanelAggiuntivi.set(false)"
    >
      <mat-expansion-panel-header>
        <mat-panel-title> Pacchetti Aggiuntivi </mat-panel-title>

        <mat-panel-description>
          @if (!this.statoPanelAggiuntivi()) {
            Apri per visualizzare maggiori informazioni sui pacchetti aggiuntivi...
          }
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div class="cont-exp">
        <div class="cont-tab">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <div style="display: flex; column-gap: 50px">
              <div class="contenitore-legenda">
                <div class="punto-legenda-attiva"></div>
                <div class="label-legenda">Pacchetto Attivo</div>
              </div>
              <div class="contenitore-legenda">
                <div class="punto-legenda-futura"></div>
                <div class="label-legenda">Prossimo Pacchetto</div>
              </div>
              <div class="contenitore-legenda">
                <div class="punto-legenda-scaduta"></div>
                <div class="label-legenda" style="font-style: italic">Pacchetto Scaduto</div>
              </div>
            </div>
            <button
              mat-flat-button
              color="primary"
              (click)="aggiungiPacchettoAggiuntivo()"
              class="primary-button"
              style="max-width: 200px !important; height: 35px !important"
            >
              <mat-icon>add</mat-icon>
              Aggiungi Pacchetto
            </button>
          </div>
          <app-lista-tabellare
            #tabellaPackAggiuntivi
            [fnCaricamentoDati]="fnCaricamentoDatiPackAggiuntivi"
            [colonne]="colonnePackAggiuntivi"
            [maxNrButton]="1"
            [isFiltri]="false"
            (bottoniListaClick)="bottoniListaClick($event)"
            [fnCaricamentoStyle]="fnCaricamentoStyle"
          >
          </app-lista-tabellare>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
